import { useCallback } from 'react'
import { useSnackbar } from 'notistack'
import { t } from '@lingui/macro'

import { parseDocumentMetadata, base64ToFile } from '../lib/xmlParser'
import { useSavePatientFile } from './useSavePatientFile'

export function useDmpDocumentNotification(patientId: string) {
  const { saveFile } = useSavePatientFile(patientId)
  const { enqueueSnackbar } = useSnackbar()

  const onDmpDocumentNotification = useCallback(
    async (xmlData: string) => {
      try {
        const metadata = parseDocumentMetadata(xmlData)
        console.log('[DmpDocument] Document metadata:', {
          uniqueId: metadata.uniqueId,
          title: metadata.title,
          typeCode: metadata.typeCode,
          format: metadata.format,
        })

        const file = base64ToFile(metadata.contentBase64, metadata.title, metadata.format)
        await saveFile(file)

        console.log('[DmpDocument] Document saved successfully:', metadata.title)
        enqueueSnackbar(t`Document "${metadata.title}" added successfully`, { variant: 'success' })
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Unknown error'
        console.error('[DmpDocument] Failed to save document:', message)
        enqueueSnackbar(t`Failed to save document: ${message}`, { variant: 'error' })
      }
    },
    [saveFile, enqueueSnackbar]
  )

  return { onDmpDocumentNotification }
}
